import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Typography,
  Link
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
  },
  imageContainer: {
    height: 64,
    width: 64,
    margin: '0 auto',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    width: '100%'
  }
}));

const FeatureCard = props => {
  const { className, feature, ...rest } = props;
  const classes = useStyles();

  return (
    <Link href={feature.url} style={{ textDecoration: 'none' }} target="_blank">
        <Card
            {...rest}
            className={clsx(classes.root, className)}
            fullWidth
        >
            <CardContent>
                <div className={classes.imageContainer}>
                    <img
                        alt="Feature"
                        className={classes.image}
                        src={feature.imageUrl}
                    />
                </div>
                <Typography
                    align="center"
                    
                    variant="h4"
                >
                    {feature.title}
                </Typography>    
            </CardContent>
        </Card>
    </Link>
  );
};

FeatureCard.propTypes = {
  className: PropTypes.string,
  feature: PropTypes.object.isRequired
};

export default FeatureCard;